import React, { memo } from 'react';
import cn from 'classnames';

import { SegmentControl } from 'ui-lib';
import useSportsNavigation from './useSportsNavigation';

import './sportsNavigation.scss';

const SportsNavigation: React.FC = () => {
    const { tabs, isCompact, withoutRender } = useSportsNavigation();

    if (withoutRender) return null;

    return (
        <div
            styleName={cn('container', {
                'is-compact': isCompact,
            })}
        >
            <SegmentControl tabs={tabs} />
        </div>
    );
};

export default memo(SportsNavigation);
